// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3kgQJ","content":"styles_content__XNq24","checkbox":"styles_checkbox__2Kqtp","checkboxLabel":"styles_checkboxLabel__2-ya4"};